import React from 'react';

const Footer = () => {
    return (
        <div style={{marginLeft:'30px'}}>
                <p style={{fontWeight:'bolder', marginBottom:'10px'}}>(주)미래를여는생각</p>
                <p style={{marginBottom:'1px'}}>주소  서울특별시 서초구 서초중앙로18길 31, 1층 14호</p>
                <p style={{marginBottom:'1px'}}>전화번호  070-8654-7225</p>
                <p style={{marginBottom:'1px'}}>대표자  최재헌</p>
                <p style={{marginBottom:'1px'}}>사업자등록번호  247-86-01602</p>
                <p>통신판매업 신고번호  제2019-서울서초-0453호</p>
        </div>
    )
}

export default Footer;